export function VersionInfo({ className = '' }: { className?: string }) {
  const version = __APP_VERSION__;
  const commit = __GIT_COMMIT__;

  return (
    <span className={`text-xs text-mist/50 ${className}`}>
      v{version}
      {commit && ` (${commit.slice(0, 7)})`}
    </span>
  );
}
